<template>
  <div>
    <div v-show="showIndex == 4 && showMsg" class="tips">
      <span>如需编辑个人信息，请在电脑端操作!</span>
      <img
        @click="closeTips"
        src="@/assets/images/main/icon-close.png"
        alt=""
      />
    </div>
    <div v-show="iphones" class="iphone-con"></div>
    <div class="footerNav" :style="iphones?'height: 40px;':''">
      <div @click="setShowIndex(1)">
        <img
          v-show="showIndex == 1"
          src="@/assets/images/main/icon-positionl.png"
          alt=""
        />
        <img
          v-show="showIndex != 1"
          src="@/assets/images/main/icon-position.png"
          alt=""
        />
        <span :style="showIndex == 1 ? 'color: #5EBFB9;' : ''">职位</span>
      </div>
      <div @click="setShowIndex(2)">
        <img
          v-show="showIndex == 2"
          src="@/assets/images/main/icon-man-l.png"
          alt=""
        />
        <img
          v-show="showIndex != 2"
          src="@/assets/images/main/icon-man.png"
          alt=""
        />
        <span :style="showIndex == 2 ? 'color: #5EBFB9;' : ''">人才库</span>
      </div>
      <div @click="setShowIndex(3)">
        <img
          v-show="showIndex == 3"
          src="@/assets/images/main/icon-tooll.png"
          alt=""
        />
        <img
          v-show="showIndex != 3"
          src="@/assets/images/main/icon-tool.png"
          alt=""
        />
        <span :style="showIndex == 3 ? 'color: #5EBFB9;' : ''">工作台</span>
      </div>
      <div @click="setShowIndex(4)">
        <img
          v-show="showIndex == 4"
          src="@/assets/images/main/icon-minel.png"
          alt=""
        />
        <img
          v-show="showIndex != 4"
          src="@/assets/images/main/icon-mine.png"
          alt=""
        />
        <span :style="showIndex == 4 ? 'color: #5EBFB9;' : ''">我的</span>
      </div>
    </div>
    <div v-show="iphones" class="iphone-con"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import { mapState, mapMutations, mapActions } from "vuex";
import Cookies from "js-cookie";
Vue.use(Toast);
export default {
  components: {},
  data() {
    return {
      showIndex: 1,
      iphones: false,
      showMsg: false,
    };
  },
  created() {
    this.setIndex();
  },
  watch: {
    $route(to, from) {
      this.setIndex();
    },
  },
  mounted() {
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      this.iphones = true;
    }
    let authInfo = Cookies.get("authInfo")
        ? JSON.parse(Cookies.get("authInfo"))
        : "";
  },
  methods: {
    ...mapMutations("position", ["setStateItem"]),
    setShowIndex(index) {
      if (index == 1 && this.$route.name != "position") {
        this.$router.push({ name: "position" });
      } else if (index == 2 && this.$route.name != "talentPool") {
        this.$router.push({ name: "talentPool" });
        return;
      } else if (index == 3 && this.$route.name != "Workbench") {
        this.$router.push({ name: "Workbench" });
        return;
      } else if (index == 4 && this.$route.name != "Personal") {
        this.$router.push({ name: "Personal" });
        this.showMsg = true;
      }
      this.showIndex = index;
    },
    setIndex() {
      if (this.$route.name == "position") {
        this.showIndex = 1;
        this.setStateItem({
          key: "tabIndex",
          value: 1,
        });
      }
      if (this.$route.name == "talentPool") {
        this.showIndex = 2;
      }
      if (this.$route.name == "Workbench") {
        this.showIndex = 3;
      }
      if (this.$route.name == "Personal") {
        this.showIndex = 4;
        this.showMsg = true;
      }
    },
    closeTips() {
      this.showMsg = false;
    },
  },
};
</script>

<style lang='scss' scoped>
body {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}
.footerNav {
  width: 100%;
  height: 60px;
  display: flex;
  font-family: PingFang SC;
  justify-content: space-around;
  align-items: center;
  background: white;
  /* margin-top: 8px; */
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    span {
      color: #bdbdbd;
      font-size: 12px;
      text-align: center;
    }
    img {
      height: 26px;
      width: 26px;
      margin-bottom: 7px;
    }
  }
}
.iphone-con {
  width: 100%;
  height: 15px;
  background: white;
}
.tips {
  height: 24px;
  color: #ffffff;
  font-size: 14px;
  line-height: 24px;
  padding: 0 15px;
  text-align: left;
  background: rgba($color: #5ebfb9, $alpha: 0.6);
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    height: 10px;
  }
}
</style>
